var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBlackTeacher(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 24,
    viewBox: "0 0 25 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Teacher"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M2.5 21C3 20.0909 4.9 18.2727 8.5 18.2727C12.1 18.2727 14 16.0909 14.5 15M8.5 8V5C8.5 3.89543 9.39543 3 10.5 3H20.5C21.6046 3 22.5 3.89543 22.5 5V13C22.5 14.1046 21.6046 15 20.5 15H17.2397M12.5 7H18.5M10.5 13C10.5 14.1046 9.60457 15 8.5 15C7.39543 15 6.5 14.1046 6.5 13C6.5 11.8954 7.39543 11 8.5 11C9.60457 11 10.5 11.8954 10.5 13Z",
    stroke: "#1E2D66",
    strokeWidth: 2,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector 1464",
    d: "M15.5 11H18.5",
    stroke: "#1E2D66",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBlackTeacher);
export default __webpack_public_path__ + "static/media/black_Teacher.973c20655931ad7a42753cfcd66ce99e.svg";
export { ForwardRef as ReactComponent };